import styled from "@emotion/styled";

export const ModalContent = styled.div`
  text-align: center;
  font-size: 1rem;
`;
